import * as React from 'react';
import { withStyles, WithStyles, createStyles, Theme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Header from './Header';
import Footer from './Footer';
import Loading from './Common/Loading';

const jss = (theme: Theme) => createStyles({
    main: {
        width: '100%',
        minHeight: 'calc(100vh - 120px)',
        backgroundColor: theme.palette.secondary.main,
    },
    paper: {
        ...theme.mixins.gutters(),
        padding: theme.spacing.unit * 2,
        maxWidth: 960,
        width: '100%',
        margin: '0px auto',
        borderRadius: '0px',
        position: 'relative',
    },
    content: {
        display: 'flex',
        minHeight: 'calc(100vh - 200px)',
        width: '100%',
        justifyContent: 'center',
    },
    '@media (min-width: 960px)': {
        paper: {
            margin: '20px auto',
            borderRadius: '4px',
            padding: theme.spacing.unit * 4,
        },
    },
    loading: {
        zIndex: 10,
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: theme.palette.background.paper,
    },
});

interface Props extends WithStyles<typeof jss> {
    children: any;
    loading: boolean;
}

export class Page extends React.Component<Props, {}> {
    render() {
        const { classes } = this.props;
        return (
            <React.Fragment>
                <CssBaseline />
                <div className={classes.main}>
                    <Header />
                    <div className={classes.content}>
                        <Paper className={classes.paper}>
                            {this.props.loading && <div className={classes.loading}><Loading /></div>}
                            {this.props.children}
                        </Paper>
                    </div>
                </div>
                <Footer />
            </React.Fragment>
        );
    }
}

export default withStyles(jss)(Page);



// WEBPACK FOOTER //
// ./src/components/Page.tsx